export default "__VITE_ASSET__yYzQ$R6S__"